import React from "react";
import { Container, Row, Col, Dropdown } from "react-bootstrap";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AppNavbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const location = useLocation();
  const currentPath = location.pathname;


  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      logout();
    }
  };

  const handleEdit = (id) => navigate(`/UserEdit/${user.uid}`);

  return (
    <div
      style={{
        width: "100%",
        background: "linear-gradient(to right, #dce6f7, #e8f0ff)",
        padding: "8px 0",                   // 🔥 Reduced to remove top gap
        borderBottom: "3px solid #99b3e6",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        position: "sticky",
        top: 0,
        zIndex: 999,
      }}
    >
      <Container fluid>
        <Row
          className="text-center justify-content-center align-items-center"
          style={{ margin: 0, padding: 0 }}   // 🔥 Removes spacing completely
        >

          <Col xs="auto">
            <Link className={`menu-link ${currentPath === "/" ? "active-menu" : ""}`} to="/">🏠 Home</Link>
          </Col>



          <Col xs="auto">
            <Dropdown>
              <Dropdown.Toggle className={`menu-dropdown ${currentPath.startsWith("/logs") || currentPath.startsWith("/clinical_report") ? "active-menu" : ""}`}>
                📑 Reports
              </Dropdown.Toggle>

              <Dropdown.Menu style={{ minWidth: "220px" }}>
                <Dropdown.Item as={Link} to="/logs">📜 Log Activity</Dropdown.Item>
                <Dropdown.Item as={Link} to="/literature_report">📘 Literature Report</Dropdown.Item>
                <Dropdown.Item as={Link} to="/clinical_report">🏥 Clinical Report</Dropdown.Item>
                <Dropdown.Item as={Link} to="/molecular_report">🧬 Molecular Report</Dropdown.Item>
                <Dropdown.Item as={Link} to="/enquiry">📄 Enquire</Dropdown.Item>

                <Dropdown.Divider />

                {/* 🔽 Download All Submenu */}
                <Dropdown drop="end">
                  <Dropdown.Toggle
                    as="div"
                    className="dropdown-item d-flex justify-content-between align-items-center"
                    style={{ cursor: "pointer" }}
                  >
                    ⬇️ Download All
                    <span>▶</span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {/* <Dropdown.Item as={Link} to="/download-center-wise">
                          🏢 Center Wise
                        </Dropdown.Item> */}

                    <Dropdown.Item as={Link} to="/Patient_report_sample_id_wise">
                      🧪 Sample ID Wise
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Dropdown.Menu>
            </Dropdown>

          </Col>

          <Col xs="auto"><Link className={`menu-link ${currentPath === "/Analytics" ? "active-menu" : ""}`} to="/Analytics">📊 Analytics</Link></Col>
          <Col xs="auto"><Link className={`menu-link ${currentPath === "/Literature_Avenue" ? "active-menu" : ""}`} to="/Literature_Avenue">📚 Literature Avenue</Link></Col>
          <Col xs="auto"><Link className={`menu-link ${currentPath === "/user-dashboard" ? "active-menu" : ""}`} to="/user-dashboard">⬆️ Insert Data</Link></Col>
          {user?.role === "1" ? (
            // ROLE 1 → SHOW DROPDOWN
            <Col xs="auto">
              <Dropdown>
                <Dropdown.Toggle
                  className={`menu-dropdown ${currentPath.startsWith("/register") ||
                      currentPath.startsWith("/clinical_report")
                      ? "active-menu"
                      : ""
                    }`}
                >
                  ⚙️ Settings
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ minWidth: "200px" }}>
                  <Dropdown.Item as={Link} to="/register">
                    👤 User Register
                  </Dropdown.Item>

                  <Dropdown.Item as={Link} to="/Center_list">
                    🏥 Center
                  </Dropdown.Item>

                  <Dropdown.Item as={Link} to="/Literature_Master">
                    📘 Literature Master
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          ) : user?.role === "0" ? (
            // ROLE 0 → SHOW SINGLE ITEM
            <Col xs="auto">
              <Link
                to="/Literature_Master"
                className={`menu-link ${currentPath.startsWith("/Literature_Master")
                    ? "active-menu"
                    : ""
                  }`}
              >
                📘 Add Literature Name
              </Link>
            </Col>
          ) : null}




          {/* LOGOUT BUTTON */}
          {user && (
            <Col xs="auto">
              <span className="menu-link logout-link" onClick={handleLogout}>🚪 Logout</span>
            </Col>
          )}

          {/* USER PROFILE DISPLAY */}
          <Col xs="auto">
            <span
              className="menu-link"
              onClick={() => handleEdit(user?.id)}
              title="View Profile"
              style={{
                fontWeight: "bold",
                cursor: "pointer",
                lineHeight: "1.2",
                display: "inline-block",
                padding: "4px 10px",
                borderRadius: "8px",
                background: "#eef4ff",
                boxShadow: "0 0 4px rgba(0,0,0,0.1)"
              }}
            >
              👤 {user?.username}
              <br />
              <small
                style={{
                  fontSize: "10px",
                  color: "#1a3d7c",
                  fontWeight: "500",
                  marginLeft: "22px",
                  display: "inline-block"
                }}
              >
                {user?.center_name}
              </small>
            </span>
          </Col>
        </Row>
      </Container>

      {/* MENU STYLE */}
      <style>
        {`
          .menu-link,
          .menu-dropdown {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            height: 38px;
            padding: 0 14px;
            font-weight: 600;
            font-size: 15px;
            text-decoration: none;
            cursor: pointer;
            color: #0047b3 !important;
            margin: 0 6px;
            transition: all 0.2s ease;
            border-radius: 6px;
            background: transparent !important;
            border: none !important;
          }

          .menu-link:hover,
          .menu-dropdown:hover {
            color: #001f5c !important;
            background: #e2ecff;
          }

          .logout-link:hover {
            color: red !important;
            transform: scale(1.1);
            background: #ffe6e6 !important;
          }

          .menu-dropdown:focus,
          .menu-dropdown:active,
          .menu-link:focus {
            outline: none !important;
            box-shadow: none !important;
          }

.active-menu {
  background: #cce0ff !important;
  color: #0047b3 !important;
  font-weight: 700;
  box-shadow: 0 0 6px rgba(0, 71, 179, 0.3);
}

        `}
      </style>
    </div>
  );
}
